import { useEffect, useState } from "react";
import { fetchBFRegs } from "@/lib/bf";

export default function BFRegRank() {
  const [d, setD] = useState(null);
  useEffect(() => { fetchBFRegs().then(setD).catch(() => setD(false)); }, []);
  if (d === false) return <p className="st-hint" data-testid="bfa-reg-error">Nu am putut încărca clasamentul înscrierilor.</p>;
  if (!d) return null;
  const top = Math.max(1, ...d.agents.map((a) => a.before));
  const sum = d.agents.reduce((s, a) => s + a.before, 0);
  return (
    <section className="invite-box" data-testid="bfa-reg-rank">
      <h3>Clasament înscrieri: saloane aduse de fiecare agent înainte de start</h3>
      <p className="st-hint" data-testid="bfa-reg-summary">{sum} saloane înscrise prin agenți înainte de start · {d.direct} înscrise fără agent (fără link personal).</p>
      {!d.agents.length ? <p className="st-hint">Încă nu există agenți cu link personal.</p> : (
        <ol className="bfa-rank">
          {d.agents.map((a, i) => (
            <li key={a.slug} data-testid={`bfa-reg-${a.slug}`}>
              <em>{i + 1}</em>
              <div>
                <b>{a.name}</b>
                <small>{a.total} {a.total === 1 ? "salon înscris" : "saloane înscrise"} în total</small>
                <i style={{ width: `${(a.before / top) * 100}%` }} />
              </div>
              <span data-testid={`bfa-reg-before-${a.slug}`}><b>{a.before}</b><small>înainte de start</small></span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
